import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authService } from '../../services/authService';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/card';

export const AuthPage = () => {
    const [authCode, setAuthCode] = useState('');
    const [timeLeft, setTimeLeft] = useState(60);
    const [error, setError] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    const fetchNewCode = async () => {
        try {
            const response = await authService.getAuthCode();
            setAuthCode(response.code);
            setTimeLeft(60);
        } catch (error) {
            console.error('Error fetching auth code:', error);
        }
    };

    const checkAuthStatus = useCallback(async () => {
        if (!authCode) return;

        try {
            const response = await authService.checkAuthStatus(authCode);
            if (response.verified) {
                await login(response.token, response.user.id);
                navigate('/'); // 홈으로 리다이렉션
            }
        } catch (error) {
            if (error.response?.status === 410) {
                setError('인증 시간이 만료되었습니다. 다시 시도해주세요.');
                fetchNewCode();
            } else if (error.response?.status === 401) {
                setError('유효하지 않은 로그인 요청입니다. Slack에서 로그인을 다시 시도해주세요.');
                navigate('/auth');
            }
        }
    }, [authCode, login, navigate]);

    // 컴포넌트 마운트 시 즉시 코드 가져오기
    useEffect(() => {
        fetchNewCode();

        // 1분마다 새로운 코드 가져오기
        const codeRefreshTimer = setInterval(() => {
            fetchNewCode();
        }, 60000);

        return () => clearInterval(codeRefreshTimer);
    }, []);

    // 카운트다운 타이머
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 0) {
                    return 60;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const pollTimer = setInterval(checkAuthStatus, 2000);
        return () => clearInterval(pollTimer);
    }, [checkAuthStatus]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <Card className="w-96">
                <CardHeader>
                    <CardTitle>PC 인증</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="space-y-4">
                        {error && (  // 에러 메시지 표시
                            <div className="text-sm text-red-500 text-center">
                                {error}
                            </div>
                        )}
                        <div className="text-center">
                            <div className="text-4xl font-mono font-bold tracking-wider bg-gray-100 p-4 rounded">
                                {authCode}
                            </div>
                            <div className="mt-2 text-sm text-gray-500">
                                남은 시간: {timeLeft}초
                            </div>
                        </div>
                        <p className="text-sm text-gray-600 text-center">
                            Slack에서 받은 링크를 모바일에서 열어<br />
                            위 코드를 입력해주세요.
                        </p>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};